import React from "react";
import styled, { keyframes } from "styled-components";
import { Navbar, Container } from "react-bootstrap";
import { LogoEmpresa } from "./App";

// Animación de carga
const loadingAnimation = keyframes`
  0% {
    opacity: 0.8;
  }
  25% {
    opacity: 0.7;
  }
  50% {
    opacity: 0.5;
  }
  75% {
    opacity: 0.7;
  }
  100% {
    opacity: 0.8;
  }
`;

// Contenedor principal del Skeleton (según tus tamaños)
const StyledNavbar = styled(Navbar)`
  background-color: #c20000 !important;
`;
const ContenedorDiv = styled.div`
  margin-top: 3rem;
  margin-bottom: 4.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%; /* Ajustar al 100% del contenedor */
`;

const DivTexto = styled.div`
  background-color: gray;
  width: 200px;
  height: 30px;
  margin: auto;
  border-radius: 10px;
  animation: ${loadingAnimation} 1.3s infinite;
`;

// Contenedor de la tabla (según tus tamaños)
const ContenedorTabla = styled.div`
  width: 95%; /* Contenedor que se adapta al ancho completo */
  overflow-x: auto; /* Habilita el desplazamiento horizontal para pantallas pequeñas */
  text-align: center;
  input {
    margin-top: 10px;
    border: none;
    border-radius: 5px;
    animation: ${loadingAnimation} 1.8s infinite;
    padding: 3px;
    width: 50%;
    background-color: #b4b4b4;
  }
`;

// Estilos de la tabla simulada (según tus tamaños)
const Tabla = styled.table`
  width: 100%; /* La tabla ocupa todo el ancho disponible */
  min-width: 900px; /* Establece un ancho mínimo para que se desplace en pantallas pequeñas */
  border-collapse: collapse;
  margin-top: 5px;
  border-radius: 3px;
  th,
  td {
    border: 2.5px solid transparent;
    white-space: nowrap; /* Evitar que se dividan en múltiples líneas */
    overflow: hidden;
    text-overflow: ellipsis; /* Texto truncado con ... si sobrepasa */
    max-height: 2.5em; /* Altura fija para una línea */
    line-height: 1.5em;
    height: 2.5em;
  }
  th {
    background-color: gray;
  }
  th.actions,
  td.actions {
    width: 60px;
  }
`;

// Encabezado de la tabla simulada
const SkeletonTableHeader = styled.th`
  background-color: #ddd;
  height: 25px;
  border-radius: 4px;
  margin-bottom: 10px;
  animation: ${loadingAnimation} 1.5s infinite;
`;

// Fila y datos de la tabla simulada
const SkeletonTableRow = styled.tr``;

const SkeletonTableData = styled.td`
  height: 25px;
  background-color: #b4b4b4;
  margin: 10px 0;
  border-radius: 4px;
  animation: ${loadingAnimation} 1.6s infinite;
`;

const SkeletonLoader = () => {
  return (
    <div>
      {/* Barra de navegación */}
      <StyledNavbar
        fixed="top"
        className="bg-body-tertiary mb-3"
        bg="dark"
        data-bs-theme="dark"
      >
        <Container fluid>
          <Navbar.Brand href="#">CataApp</Navbar.Brand>
        </Container>
        <LogoEmpresa></LogoEmpresa>
      </StyledNavbar>

      {/* Contenedor principal con la tabla simulada */}
      <ContenedorDiv>
        <ContenedorTabla>
          <DivTexto></DivTexto>
          <input
            type="text"
          />
          <Tabla>
            <thead>
              <tr>
                <SkeletonTableHeader></SkeletonTableHeader>
                <SkeletonTableHeader></SkeletonTableHeader>
                <SkeletonTableHeader></SkeletonTableHeader>
                <SkeletonTableHeader></SkeletonTableHeader>
                <SkeletonTableHeader></SkeletonTableHeader>
              </tr>
            </thead>
            <tbody>
              {/* Simulación de varias filas con datos vacíos */}
              {Array(8)
                .fill("")
                .map((_, index) => (
                  <SkeletonTableRow key={index}>
                    <SkeletonTableData></SkeletonTableData>
                    <SkeletonTableData></SkeletonTableData>
                    <SkeletonTableData></SkeletonTableData>
                    <SkeletonTableData></SkeletonTableData>
                    <SkeletonTableData></SkeletonTableData>
                  </SkeletonTableRow>
                ))}
            </tbody>
          </Tabla>
        </ContenedorTabla>
      </ContenedorDiv>
    </div>
  );
};

export default SkeletonLoader;
